import React, { useEffect, useState } from "react"
import styles from './BaseList.module.css'
import mstyles from "../MilUnitList/Unit.module.css"
import { axiosInstance } from "../../Helpers/axiosInstance";
import { BACKEND_URL } from "../../Helpers/constants";

const View  = () => {
    const [units, setUnits] = useState([])
    const [isBaseListShown, setIsBaseListShown] = useState(false)
    const [selectedUnit, setSelectedUnit] = useState(null)
    const [selectedBase, setSelectedBase] = useState(null)
    const [base, setBase] = useState(null)

      const fetchUnits = async () => {
        try {
          const response = await axiosInstance.get('admin/milunits');
          setUnits(response.data.data);
        } catch (error) {
          console.error("Error fetching units:", error);
        }
      };

  
    const fetchBase = async (base_id) => {
        if (!base_id) return; 
        try {
          let baseik = base_id
          const response = await axiosInstance.get(`/admin/base/${baseik}`);
          setBase(response.data.data);
        } catch (error) {
          console.error("Error fetching bases:", error);
        }
      };

    const selectBase = (item) => {
        if(base && base._id === item.base_id) {
            setSelectedBase(null)
            setBase(null)
        }else{
            setSelectedBase(item.base_id); fetchBase(item.base_id)
        }
    }

    const getBaseExcel = async () => {
        const res = await axiosInstance.get(`/admin/base-excel/${base._id}`)
        const { filePath } = res.data.data;

        const downloadLink = document.createElement("a");
        downloadLink.href = BACKEND_URL + filePath;
        downloadLink.download = "data.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    const getBaseWord =  async () => {
        const res = await axiosInstance.get(`/admin/base-word/${base._id}`)
        const { filePath } = res.data.data;

        const downloadLink = document.createElement("a");
        downloadLink.href = BACKEND_URL + filePath;
        downloadLink.download = "data.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    const getUnitExcel = async () => {
        const res = await axiosInstance.get(`/admin/bases-excel/${selectedUnit._id}`)
        const { filePath } = res.data.data;

        const downloadLink = document.createElement("a");
        downloadLink.href = BACKEND_URL + filePath;
        downloadLink.download = "data.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    const getUnitWord =  async () => {
        const res = await axiosInstance.get(`/admin/bases-word/${selectedUnit._id}`)
        const { filePath } = res.data.data;

        const downloadLink = document.createElement("a");
        downloadLink.href = BACKEND_URL + filePath;
        downloadLink.download = "data.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }



      useEffect(() => {fetchUnits()}, [])
    return (
        <div className={styles['View-Correct-main-div']}>
            <h2>
                {!isBaseListShown ? "Զորամասեր" : "Հենակետերի աղյուսակ"}
            </h2>
            {/* <span className={styles['print-btn']} onClick={() => window.print()}>Տպել</span>  */}
            <div className={styles["editing-list-veiw"]}>
                {!isBaseListShown && units.length && units.map(((el, i) => (
                    <div className={mstyles["editing-items"]} key={el._id} onClick={() => {setSelectedUnit(el); setIsBaseListShown(true)}}>
                        {i + 1}. {el.unit_number}
                        {/* {el.unit_bases.length && el.unit_bases.map(item => (
                            <div className={styles['each-base']} key={item.base_id}>
                                <div className={styles['each-number']}>{item.base_number}</div>
                            </div>
                        ))} */}
                    </div>
                )))}
                {selectedUnit && isBaseListShown && !!selectedUnit.unit_bases.length && selectedUnit.unit_bases.map((item, index) => (
                    <div className={styles['list-of-bases']} key={index} onClick={() => {selectBase(item)}}>
                        <div className={`${styles['every-base']} ${selectedBase === item.base_id ? styles["selected"]: ""}`}>
                            <div className={styles['every-number']}>{index + 1}. {item.base_number}</div>
                            <div className={styles['every-number']}>{item.base_name}</div>
                        </div>
                        {base && base._id === item.base_id && (<div className={styles['base-main-information']}>
                            <div className={styles['base-main-tr']}>{`${base.base_number} մարտական դիրք (${base.base_cordinates}) ${base.base_cameraes ? "(Տեղադրված է համակցված տեսադիտարկման համակարգ)" : "" } ${base.base_company}ՀՎ հենակետ, պատասխանատու\` ${base.base_responsible}, մնալով ${base.base_responsible_location} մ/դ-ում `}</div>
                            <div className={styles['base-info-headers']}>
                                <div className={styles['per5']}>Հ/Հ</div>
                                <div className={styles['per10']}>Զինկո­չում</div>
                                <div className={styles['per5']}>Զ/կոչ</div>
                                <div className={styles['per20']}>Անուն, ազգանուն, հայրանուն</div>
                                <div className={styles['per15']}>Ստորաբաժանում</div>
                                <div className={styles['per15']}>Պաշտոնը</div>
                                <div className={styles['per10']}>Զենքի տեսակը</div>
                                <div className={styles['per10']}>Զենքի համարը</div>
                                <div className={styles['per10']}>Այլ տվյալներ</div>
                            </div>
                            <ol>
                                {!!base.base_information.length && base.base_information.map((el, index) => 
                                    <li key={index} className={`${styles['base-info-headers']} ${styles['base-info-list']}`}>
                                        <p className={styles['per5']}>{index + 1}.</p>
                                        <p className={styles['per10']}>{el.rang}</p>
                                        <p className={styles['per5']}>{el.conscription}</p>
                                        <p className={styles['per20']}>{el.full_name}</p>
                                        <p className={styles['per15']}>{el.subvision}</p>
                                        <p className={styles['per15']}>{el.position}</p>
                                        <p className={styles['per10']}>{el.gun_type}</p>
                                        <p className={styles['per10']}>{el.gun_number}</p>
                                        <p className={styles['per10']}>{el.other_information}</p>
                                    </li>
                                )}
                            </ol>
                            <div className={styles["convertsion"]}>
                                <img src="/word.png" alt="word" title="Ստանալ ֆայլ հենակետերի համար" onClick={getBaseWord}/>
                                <img src="/excel.png" alt="excel" title="Ստանալ ֆայլ հենակետերի համար" onClick={getBaseExcel}/>
                            </div>
                        </div>)}
                    </div>
                ))}
                {selectedUnit && <div className={styles["all-convertsion"]}>
                    <img src="/word.png" alt="word" title="Ստանալ ֆայլ զորամասի բոլոր հենակետերի համար"  onClick={getUnitWord}/>
                    <img src="/excel.png" alt="excel" title="Ստանալ ֆայլ զորամասի բոլոր հենակետերի համար" onClick={getUnitExcel}/>
                </div>}

            </div>
            
        </div>
    )
}


export default View